import { useState, useEffect } from "react";
import FNF from "../../images/FNf.png";
import FN2 from "../../images/FNU.png";
import frontendedit from "../../images/FRONT PAGE EDITABLE.png";
import imageplaceholder from "../../images/cropImage.png";
import jsPDF from "jspdf";
import "jspdf-autotable"; // For tables
import { addFontsToPDF, getFontForText } from "./Pdfhelper";
import axios from "axios";

export default async function PrintFakeNews(serverResponses) {
  function getFormattedDate() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const pdfToSimple = getFormattedDate();
  const pdf = new jsPDF("p", "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // Add fonts if you have custom ones
  addFontsToPDF(pdf);

  // Add cover page
  pdf.addImage(frontendedit, "JPEG", 0, 0, pageWidth, pageHeight);
  pdf.setTextColor(41, 58, 102);
  pdf.setFontSize(26);

  if (pdfToSimple) {
    pdf.setFont(undefined, "bold");
    pdf.text(`  ${pdfToSimple}`, 125, 207);
  }

  pdf.addPage();

  // Now process each server response
  for (const [index, data] of serverResponses.entries()) {
    if (index > 0) pdf.addPage();

    pdf.addImage(FN2, "JPEG", 0, 0, pageWidth, pageHeight);

    let y = 45;
    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 0);

    const textWidth = 160;
    const fieldNameSpacing = 3;
    const fullWidth = pageWidth - 20;
    const leftX = 10;
    const rightX = pageWidth / 2 + 10;
    const imgWidth = pageWidth / 2 - 20;
    const imgHeight = 40;

    // Claim
    pdf.setFont("helvetica", "bold");
    pdf.text("Claim :", 10, y);
    pdf.setFont("helvetica", "normal");

    const initialClaim = String(data.claim || "");
    const initialClaimLabelWidth =
      pdf.getTextWidth("Claim : ") + fieldNameSpacing;
    const firstLineWidth = fullWidth - initialClaimLabelWidth;

    let initialFirstLine = initialClaim;
    let initialRemainingText = "";

    if (pdf.getTextWidth(initialFirstLine) > firstLineWidth) {
      let charLimit = 0;
      while (
        charLimit < initialFirstLine.length &&
        pdf.getTextWidth(initialFirstLine.substring(0, charLimit)) <
          firstLineWidth
      ) {
        charLimit++;
      }
      while (charLimit > 0 && initialFirstLine[charLimit] !== " ") {
        charLimit--;
      }
      initialRemainingText = initialFirstLine.substring(charLimit).trim();
      initialFirstLine = initialFirstLine.substring(0, charLimit);
    }

    let fontForFirstLine = getFontForText(pdf, initialFirstLine);
    pdf.setFont(fontForFirstLine, "normal");
    pdf.text(initialFirstLine, 10 + initialClaimLabelWidth, y);

    let initialY = y + 5;
    if (initialRemainingText) {
      const remainingLines = pdf.splitTextToSize(
        initialRemainingText,
        fullWidth
      );
      remainingLines.forEach((line) => {
        const font = getFontForText(pdf, line);
        pdf.setFont(font, "normal");
        pdf.text(line, 10, initialY);
        initialY += 5;
      });
    }

    y = initialY + 5;

    // Platform
    pdf.setFont("helvetica", "bold");
    pdf.text("Platform:", 10, y);
    pdf.setFont("helvetica", "normal");
    pdf.text(data.origin || "N/A", 30, y);
    y += 10;

    // Image
    pdf.setFont("helvetica", "bold");
    pdf.text("Image:", leftX + 20, y);
    pdf.setFont("helvetica", "normal");

    const imgUrl = `http://10.226..111:5000/getImage?ObjectId=${data._id}`;

    try {
      const response = await axios.get(imgUrl, { responseType: "blob" });
      const imgBlob = URL.createObjectURL(response.data);
      const image = new Image();
      image.src = imgBlob;
      await new Promise((resolve) => (image.onload = resolve));

      const imgOriginalWidth = image.width;
      const imgOriginalHeight = image.height;
      const maxWidth = imgWidth - 30;
      const ratio = maxWidth / imgOriginalWidth;
      const finalWidth = maxWidth;
      const finalHeight = imgOriginalHeight * ratio;

      pdf.addImage(image, "JPEG", leftX, y + 2, finalWidth, finalHeight);
      pdf.link(leftX, y + 5, imgWidth, imgHeight, { url: imgUrl });
    } catch (err) {
      // fallback if image fails
      pdf.text("Image not available", leftX, y + 10);
    }

    // Classification Table
    pdf.setFont("helvetica", "bold");
    pdf.text("Classification:", rightX + 10, y);
    pdf.setFont("helvetica", "normal");
    y += 3;

    pdf.autoTable({
      startY: y,
      margin: { left: rightX },
      head: [["Model Prediction", "Fact Check"]],
      body: [[data.model_prediction || "", data.fact_check || ""]],
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 3 },
      columnStyles: {
        0: { cellWidth: imgWidth / 2 },
        1: { cellWidth: imgWidth / 2 },
      },
    });

    y = pdf.autoTable.previous.finalY + 10;

    // Conclusion & Confidence
    pdf.setFont("helvetica", "bold");
    pdf.text("Conclusion:", rightX + 12, y);
    pdf.setFont("helvetica", "normal");
    pdf.text(data.final_result || "N/A", rightX + 42, y);
    y += 5;

    pdf.setFont("helvetica", "bold");
    pdf.text("Confidence Level:", rightX + 12, y);
    pdf.setFont("helvetica", "normal");
    const confidenceValue = data.confidence_level
      ? `${data.confidence_level}%`
      : "N/A";
    pdf.text(confidenceValue, rightX + 52, y);

    y += 20;

    // References
    pdf.setFont("helvetica", "bold");
    pdf.text("References:", 10, y);
    pdf.setFont("helvetica", "normal");

    const referencesLabelWidth =
      pdf.getTextWidth("References: ") + fieldNameSpacing;
    const fullWidths = pageWidth - 20;

    if (!data.fact || data.fact === "n/a") {
      const classificationMessage = "Fact Not Available";
      const wrappedMessage = pdf.splitTextToSize(
        classificationMessage,
        fullWidths
      );
      let currentY = y;
      wrappedMessage.forEach((line) => {
        pdf.text(line, 10, currentY + 8);
        currentY += 5;
      });
      y = currentY;
    } else {
      let words = data.fact.split(/\s+/).slice(0, 400);
      let trimmedDescription = words.join(" ");
      const wrappedRef = pdf.splitTextToSize(
        trimmedDescription,
        fullWidths - referencesLabelWidth
      );

      wrappedRef.forEach((line, idx) => {
        const font = getFontForText(pdf, line);
        pdf.setFont(font, "normal");
        const startX = idx === 0 ? 10 + referencesLabelWidth : 10;
        pdf.text(line, startX, y);
        y += 5;
      });
    }

    y += 10;

    // Fact Check Sources
    pdf.setFont("helvetica", "bold");
    pdf.text("Fact Check Sources:", 10, y);
    pdf.setFont("helvetica", "normal");

    const sources = Array.isArray(data.source) ? data.source : [];
    sources.forEach((src) => {
      if (src) {
        const wrappedSrc = pdf.splitTextToSize(src, fullWidths);
        wrappedSrc.forEach((line) => {
          pdf.text(line, 10, y);
          y += 5;
        });
        y += 2; // Small gap between sources
      }
    });
  }

  // Save the final pdf
  pdf.save("FactCheckReport.pdf");
}
